import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AppointmentState } from "../types/appointmentType";
const useAppointmentStore = create(
  persist<AppointmentState>(
    (set) => ({
      selectedSpecialization: null,
      selectedFacility: null,
      selectedDoctor: null,
      selectedDate: null,
      selectedStartTime: null,
      selectedEndTime: null,
      user: null,
      setUser: (user) => set({ user }),
      setSelectedSpecialization: (specialization) =>
        set({ selectedSpecialization: specialization }),
      setSelectedFacility: (facility) => set({ selectedFacility: facility }),
      setSelectedDoctor: (doctor) => set({ selectedDoctor: doctor }),
      setSelectedDate: (date) => set({ selectedDate: date }),
      setSelectedStartTime: (time) => set({ selectedStartTime: time }),
      setSelectedEndTime: (time) => set({ selectedEndTime: time }),
      clearAppointmentData: () =>
        set({
          selectedSpecialization: null,
          selectedDoctor: null,
          selectedDate: null,
          selectedStartTime: null,
          selectedEndTime: null,
        }),
    }),
    {
      name: "appointment-storage",
    }
  )
);
export default useAppointmentStore;
